var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.9484 7.66665C13.9485 8.35041 13.3941 8.90476 12.7104 8.90474L3.95565 8.90476C3.27189 8.90474 2.71757 8.35042 2.71755 7.66665C2.71756 6.98292 3.27191 6.42857 3.95564 6.42856L12.7103 6.42855C13.3941 6.42857 13.9484 6.98288 13.9484 7.66665Z","fill":"#606C77","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.5966 6.80236C14.0739 7.27966 14.0739 8.05352 13.5966 8.53084L10.1396 11.9878C9.66231 12.4651 8.88845 12.4651 8.41115 11.9878C7.93385 11.5105 7.93383 10.7366 8.41115 10.2593L11.0039 7.6666L8.41115 5.07388C7.93385 4.59657 7.93383 3.82271 8.41115 3.34539C8.88847 2.86807 9.66233 2.86809 10.1396 3.34539L13.5966 6.80236Z","fill":"#606C77","key":1})]);
}

ArrowRight.defaultProps = {"viewBox":"0 0 16 16","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
